import React, { useState } from 'react';
import { XIcon, MailIcon } from 'lucide-react';
interface EmailSignupPopupProps {
  isOpen: boolean;
  onClose: () => void;
}
export const EmailSignupPopup = ({
  isOpen,
  onClose
}: EmailSignupPopupProps) => {
  const [email, setEmail] = useState('');
  if (!isOpen) return null;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Here you would typically send the email to your backend
    console.log('Submitting email:', email);
    onClose();
  };
  return <div className="fixed bottom-0 left-0 right-0 z-50 bg-white shadow-lg border-t border-gray-200 animate-slide-up" data-id="element-76">
      <div className="container mx-auto px-4 py-4 md:py-6" data-id="element-77">
        <button onClick={onClose} className="absolute top-3 right-3 text-gray-400 hover:text-gray-600" aria-label="Close" data-id="element-78">
          <XIcon size={20} data-id="element-79" />
        </button>
        <div className="md:flex md:items-center md:justify-between" data-id="element-80">
          <div className="mb-4 md:mb-0 md:mr-6 md:flex-1" data-id="element-81">
            <h2 className="text-xl md:text-2xl font-bold text-gray-900" data-id="element-82">
              Sign up for PROTOCOL Flagship
            </h2>
            <p className="mt-1 text-gray-600 text-sm md:text-base" data-id="element-83">
              The daily global news briefing you can trust. In your inbox, twice
              every weekday.
            </p>
          </div>
          <form onSubmit={handleSubmit} className="md:flex-1 lg:flex-none lg:w-1/3" data-id="element-84">
            <div className="flex flex-col sm:flex-row gap-3" data-id="element-85">
              <div className="relative flex-1" data-id="element-86">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-87">
                  <MailIcon className="h-5 w-5 text-gray-400" aria-hidden="true" data-id="element-88" />
                </div>
                <input type="email" id="email-address" className="focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-md" placeholder="Your email address" required value={email} onChange={e => setEmail(e.target.value)} data-id="element-89" />
              </div>
              <button type="submit" className="flex-none px-4 py-3 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-black hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-90">
                Sign up for free
              </button>
            </div>
          </form>
        </div>
        <div className="mt-3 flex justify-end" data-id="element-91">
          <button onClick={onClose} className="text-sm text-gray-600 hover:text-blue-600" data-id="element-92">
            Not now, take me back to the news
          </button>
        </div>
      </div>
    </div>;
};